import React from 'react'

/**
 * 携程商旅引导文字组件（Phase 4 US3）
 *
 * 在符合条件的申请详情页（APPROVED + 跨城 + 部门承担）的审批预览下方展示。
 * 样式采用 Claymorphism 风格，蓝色系色调。
 *
 * 显示条件由父组件 index.tsx 控制，本组件为纯展示，无 props。
 */
const CtripGuideText: React.FC = () => {
  return (
    <div
      className="bg-blue-50 rounded-3xl shadow-inner px-5 py-4 mt-4"
      style={{
        boxShadow: 'inset 2px 2px 6px rgba(147, 197, 253, 0.5), 2px 2px 8px rgba(219, 234, 254, 0.8)',
        border: '1px solid rgba(147, 197, 253, 0.4)',
      }}
    >
      <div className="flex items-start gap-3">
        <div
          className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-2xl flex items-center justify-center"
          style={{ boxShadow: '1px 1px 4px rgba(147, 197, 253, 0.6)' }}
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            className="w-4 h-4 text-blue-500"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <div>
          <p className="text-blue-700 text-sm font-medium leading-relaxed">
            携程商旅授权已同步
          </p>
          <p className="text-blue-600 text-sm mt-1 leading-relaxed">
            审批通过后，出差单将自动同步至携程、分贝通，您可前往进行预订。
          </p>
        </div>
      </div>
    </div>
  )
}

export default CtripGuideText
